<div *ngIf="statsAndResources" class="stats-and-resources-box"
     [ngClass]="{'stats-and-resources-box-more-information' : statsAndResources.usersResources && bulkPrintIsAvailable()}">
    <div class="tile-box">
        <app-manage-subscriptions [package]="statsAndResources.package" [endDate]="statsAndResources.endDate">
        </app-manage-subscriptions>
    </div>
    <div class="tile-box">
        <app-add-more-resources-card [resource]="resourceTypes.devices"
                                     [currentCount]="statsAndResources.devicesResources.currentDeviceCount"
                                     [priceForOneUnit]="statsAndResources.devicesResources.priceForOneUnit"
                                     [totalCount]="statsAndResources.devicesResources.totalDeviceCount"
                                     [totalLimit]="statsAndResources.devicesResources.totalDevicesLimit"
                                     [currency]="statsAndResources.currency"
                                     [title]="'common.devices'"
                                     [description]="'stats-and-resources.number-printer'"
                                     [button]="'stats-and-resources.add-more-devices'"
                                     [doughnutHeight]="110"
                                     [doughnutWidth]="110"
                                     [isActive]="statsAndResources.devicesResources.isActive">
        </app-add-more-resources-card>
    </div>
    <div class="tile-box">
        <app-add-more-resources-card [resource]="resourceTypes.transfer"
                                     [currentCount]="statsAndResources.transferResources.currentTransfer"
                                     [priceForOneUnit]="statsAndResources.transferResources.priceForOneUnit"
                                     [totalCount]="statsAndResources.transferResources.totalTransfer"
                                     [totalLimit]="statsAndResources.transferResources.totalTransferLimit"
                                     [renewalDate]="statsAndResources.renewalDate"
                                     [currency]="statsAndResources.currency"
                                     [title]="'stats-and-resources.transfer'"
                                     [button]="'stats-and-resources.add-more-transfer'"
                                     [doughnutHeight]="110"
                                     [doughnutWidth]="110"
                                     [isActive]="statsAndResources.transferResources.isActive"
                                     class="dashboard">
        </app-add-more-resources-card>
    </div>
</div>
